module.exports = __webpack_public_path__ + "5c114213/img/revit-icon.5ff0d581.svg";